import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered:', registration.scope);
      })
      .catch((error) => {
        console.log('SW registration failed:', error);
      });
  });
}

// Fix for browser extensions that modify the DOM (Google Translate, Grammarly, etc.)
// This prevents "removeChild" errors when React tries to unmount elements
const container = document.getElementById("root");
if (container) {
  // Remove any text nodes that extensions might have added
  const observer = new MutationObserver(() => {
    // Silently handle DOM modifications from extensions
  });
  observer.observe(container, { childList: true, subtree: true });
}

const root = ReactDOM.createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
